import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalVariablesService {

    userName = signal<string>("");
    isNavFixed = signal<boolean>(false);
    onChangePasswordScreen = signal<boolean>(false);
}
